export default "__VITE_ASSET__CUElpaGb__"